import React from "react";
import useReportTasks from "components/pages/transmissions/modal/detail/notes/task/useReportTasks";

import {
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

const ReportTask = ({ task, index, handleEdit }) => {
  const { isArchiveReport, theme } = useReportTasks();

  return (
    <ListItem
      key={task}
      style={{
        backgroundColor: theme.palette.type === "dark" ? "#333333" : "#f5f5f5",
        borderRadius: "4px",
      }}
    >
      <ListItemText primary={task?.description} />
      <ListItemSecondaryAction>
        <IconButton
          edge="end"
          aria-label="edit-task"
          onClick={() => {
            if (!isArchiveReport) {
              handleEdit(index, task);
            }
          }}
        >
          <EditIcon data-action="edit-report-task-icon" />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default ReportTask;
